import { render } from "./ResponseStats.vue?vue&type=template&id=71d6bbf2"
import script from "./ResponseStats.vue?vue&type=script&lang=js"
export * from "./ResponseStats.vue?vue&type=script&lang=js"
script.render = render

export default script